export enum CustomerModerationAttributeEnum {
  Name = 1,
  Name2 = 2,
  Logo = 3,
  LogoThumbnail = 4,
  Industry = 5,
  NumberOfEmployees = 6,
  City = 7,
  Website = 8,
  PublicEmail = 9,
  Description = 10,
}

export enum BrandingModerationAttributeEnum {
  AnnouncementDetailsDesktopBgImage = 1,
  AnnouncementDetailsMobileBgImage = 2,
  AnnouncementDetailsBgColor = 3,
  AnnouncementTileColor = 4,
  CustomerDetailsBgColor = 5,
  CoverImage = 6,
}
